import { SystemEvent, SystemEventLevel } from 'bernie-logger';
/**
 * Format: BEX_API_${SPINNER_NAME}_${QUERY_NAME}_ERROR
 *
 * QUERY_NAME should be followed by FETCH only if it's a query.
 */
export var SOURCE_EVENTS = {
  BEX_API_SEARCH_ERROR: new SystemEvent(SystemEventLevel.ERROR, 'BEX_API_ACTIVITIES_SEARCH_ERROR')
};